import { Component } from '@angular/core';

import { Subject } from 'rxjs';
import { MatTabChangeEvent } from '@angular/material/tabs';

import { PerimetreFilters } from '../entities/perimetre-filters.entity';
import { TypeResponsabilite } from '../../../perimetres/entities/type-responsabilite.entity';

@Component({
	selector: 'consultation-perimetre',
	templateUrl: 'consultation-perimetre.html',
	styleUrls: ['consultation-perimetre.css'],
})
export class ConsultationPerimetreComponent {

	filters$ = new Subject<PerimetreFilters>();
	typeResponsabiliteCac: TypeResponsabilite = 'CAC';
	typeResponsabiliteCc: TypeResponsabilite = 'CC';
	
	refreshCcCommand = new Subject<void>();
	refreshCacCommand = new Subject<void>();
	
	constructor() {

	}
	
	tabHasChanged(tabChangeEvent: MatTabChangeEvent) {
		console.log('tabHasChanged: ', tabChangeEvent);
		if (tabChangeEvent.index === 0) {
			this.refreshCacCommand.next();
		} else if (tabChangeEvent.index === 1) {
			this.refreshCcCommand.next();
		}
	}
}
